import { Component, ElementRef, Input, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';

import { Chart, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { TimeFrameMode } from 'src/app/shared/interfaces/global-filter-model';
import * as $ from 'jquery';

Chart.register(...registerables, ChartDataLabels);

@Component({
  selector: 'app-line-fte-chart',
  templateUrl: './line-fte-chart.component.html',
  styleUrls: ['./line-fte-chart.component.scss'],
})
export class LineFteChartComponent {
  @Input() chartData: any;
  @Input() view: any;
  public fteData = [];

  chartObj1: any;
  chartObj2: any;
  public manufacturing_data: any = [];
  public linesData: any = [];
  public fteDataLabel: any[] = [];

  private subs = new Subscription();

  @ViewChild('chartBox', { static: false }) chartBox: ElementRef;

  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.chartObj1?.destroy();
    this.chartObj2?.destroy();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['chartData'].currentValue != changes['chartData'].previousValue) {
      this.initLinesFteChartData();
      this.fteDataLabel = this.fte();
    }
  }

  initLinesFteChartData() {
    var existingChart1 = Chart.getChart('barChart1');
    if (existingChart1) {
      existingChart1.destroy();
    }
    var existingChart2 = Chart.getChart('barChart2');
    if (existingChart2) {
      existingChart2.destroy();
    }
    this.manufacturing_data = this.chartData?.keys;
    let min_width = $('.chart-card').width() - 50;
    let width = this.manufacturing_data.length * 120;
    $('.box').css('width', Math.min(width));
    $('.box').css('min-width', Math.min(min_width));

    if (this.chartData && this.chartData.keys.length > 0) {
      this.manufacturing_data = this.chartData.keys;
      this.linesData = this.chartData.new_line;
      this.fteData = this.chartData.fte;

      const customPlugin = {
        id: 'imageItems',
        afterDraw: function (chart) {
          const ctx = chart.ctx;
          const xAxis = chart.scales['x'];
          chart.data.labels.forEach((label, index) => {
            const imageName = chart.data.datasets[1].data[index].toLowerCase(); // Get the image name from the array
            const img = new Image();
            // img.src = `/assets/images/Brand-Logos/${imageName}`;
            // ctx.drawImage(img, xAxis.getPixelForValue(index) - 25, xAxis.bottom - 0, 40, 40);
          });
        },
      };
      const ctx1 = document.getElementById('barChart1') as HTMLCanvasElement;
      this.chartObj1 = new Chart(ctx1, {
        type: 'bar',
        data: {
          labels: this.manufacturing_data,
          datasets: [
            {
              label: 'Lines',
              backgroundColor: '#C4C4CD',
              data: this.linesData,
              yAxisID: 'lines_Yaxis',
              borderRadius: 4,
              hoverBackgroundColor: '#E1E1E6',
              datalabels: {
                color: '#2E2E38 ',
                backgroundColor: '#EAEAF2',
                borderColor: '#2E2E38 ',
                borderRadius: 41,
                borderWidth: 1,
                anchor: 'end',
                align: 'top',
                font: {
                  size: 16,
                  weight: 'bold',
                },
                padding: {
                  top: 2,
                  bottom: 2,
                  left: 10,
                  right: 10,
                },
              },
            },
            // {
            //   label: 'FTEs',
            //   backgroundColor: '#FDEBCB',
            //   data: this.fteData,
            //   yAxisID: 'FTEs_Yaxis',
            //   borderRadius: 4,
            //   hoverBackgroundColor: '#FAF3E3',
            //   datalabels: {
            //     color: '#483719',
            //     backgroundColor: '#FDEBCB',
            //     borderColor: '#483719',
            //     borderRadius: 41,
            //     borderWidth: 1,
            //     anchor: 'end',
            //     align: 'top',
            //     font: {
            //       size: 16,
            //       weight: 'bold',
            //     },
            //     padding: {
            //       top: 2,
            //       bottom: 2,
            //       left: 10,
            //       right: 10,
            //     },
            //   },
            // },
            {
              label: 'Logos',
              backgroundColor: '#F8EFDA',
              data: this.chartData.brand_logo,
              yAxisID: 'FTEs_Yaxis',
              borderRadius: 4,
              hidden: true,
            },
          ],
        },
        options: {
          maintainAspectRatio: false,
          layout: {
            padding: {
              top: 30,
              bottom: 40,
            },
          },
          scales: {
            x: {
              ticks: {
                display: false,
                font: {
                  size: 18,
                  weight: 'normal',
                  family: 'Calibri',
                  lineHeight: 'normal',
                },
                color: '#000000',
              },
              beginAtZero: false,
              grid: {
                display: false,
              },
            },
            lines_Yaxis: {
              ticks: {
                display: false,
                font: {
                  size: 18,
                  weight: 'normal',
                  family: 'Calibri',
                  lineHeight: 'normal',
                },
                color: '#000000',
              },
              border: {
                display: false,
              },
              grid: {
                display: true,
                drawTicks: false,
              },
            },
            FTEs_Yaxis: {
              display: false,
              ticks: {
                font: {
                  size: 18,
                  weight: 'normal',
                  family: 'Calibri',
                  lineHeight: 'normal',
                },
                color: '#000000',
              },
              title: {
                display: false,
                text: 'Total # FTEs',
                font: {
                  size: 16,
                  weight: 'normal',
                },
                color: '#281138',
              },
              border: {
                display: false,
              },
              type: 'linear',
              position: 'right',
              grid: {
                display: true,
                drawOnChartArea: false,
              },
            },
          },
          plugins: {
            datalabels: {
              display: true,
              color: 'black', // Color of the data labels
              anchor: 'end', // Position of the labels: start, center, end
              align: 'top', // Alignment of the labels: start, center, end
              backgroundColor: '#EAEAF2',
              borderColor: '#292928',
              borderRadius: 20,
              borderWidth: 1,
              padding: {
                top: 4,
                bottom: 4,
                left: 8,
                right: 8,
              },
              // formatter: (value: any) => {
              //   let val = parseFloat(value).toFixed(1);
              //   return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              // },
            },
            legend: {
              display: false,
            },
          },
        },
        plugins: [customPlugin],
      });

      const ctx2 = document.getElementById('barChart2') as HTMLCanvasElement;

      this.chartObj2 = new Chart(ctx2, {
        type: 'bar',
        data: {
          labels: this.manufacturing_data,
          datasets: [
            {
              label: 'Lines',
              data: this.linesData,
              yAxisID: 'lines_Yaxis',
            },
            {
              label: 'FTEs',
              data: this.fteData,
              yAxisID: 'FTEs_Yaxis',
            },
          ],
        },
        options: {
          // indexAxis: 'x',
          maintainAspectRatio: false,
          layout: {
            padding: {
              bottom: 50,
              top: 28,
            },
          },
          scales: {
            x: {
              grid: {
                display: false,
                drawOnChartArea: false,
                drawTicks: false,
              },
              ticks: {
                display: false,
              },
              border: {
                display: false,
              },
            },
            lines_Yaxis: {
              display: false,
              title: {
                display: false,
                text: 'Total # of Lines',
                font: {
                  size: 16,
                  weight: 'normal',
                },
                color: '#35164B',
              },
              type: 'linear',
              position: 'left',
              ticks: {
                display: false,
                font: {
                  size: 18,
                  weight: 'normal',
                  family: 'Calibri',
                  lineHeight: 'normal',
                },
                color: '#000000',
              },
              grid: {
                display: false,
                drawOnChartArea: false,
              },
              border: {
                display: false,
              },
              beginAtZero: true,
              afterFit: (ctx) => {
                ctx.width = 49;
              },
            },
            FTEs_Yaxis: {
              display: false,
              title: {
                display: false,
                text: 'Total # FTEs',
                font: {
                  size: 16,
                  weight: 'normal',
                },
              },
              type: 'linear',
              position: 'right',
              ticks: {
                display: false,
              },
              grid: {
                display: false,
                drawOnChartArea: false,
                drawTicks: false,
              },
              border: {
                display: false,
              },
              beginAtZero: true,
              afterFit: (ctx) => {
                ctx.width = 50;
              },
            },
          },
          plugins: {
            datalabels: {
              display: false,
            },
            legend: {
              display: false,
            },
          },
        },
        // plugins: [customPlugin],
      });

      const barLength = this.chartObj1.data.labels.length;
      const chartWidth = 850 + (barLength - 8) * 90;
      this.renderer.setStyle(this.chartBox.nativeElement, 'width', `${chartWidth}px`);
    }
  }

  fte() {
    return [
      {
        label: 'Total New Lines',
        value: this.chartData?.new_line_count,
        prefix: '',
        suffix: '',
      },
      {
        label: 'Total FTEs',
        value: this.chartData?.fte,
        prefix: '',
        suffix: '',
      },
    ];
  }
}
